import { jsx as s } from "react/jsx-runtime";
import { propagateTestid as a } from "./utils/helpers.js";
const e = "ids-navbar-v501", d = "ids-navbar--logo-image-v501", r = "ids-navbar--panel-v501", v = "ids-navbar--logo-slot-v501", l = "ids-navbar--content-v501", p = "ids-navbar--content-between-v501", b = "ids-navbar--content-end-v501", c = "ids-navbar--toggle-button-v501", g = "ids-navbar--logo-icon-v501", m = "ids-navbar--slot-v501", u = "ids-navbar--logo-link-v501", k = "ids-navbar--fixed-v501", x = "ids-navbar--nav-hide-v501", f = {
  navbar: e,
  "ids-icon": "ids-icon-v501",
  "ids-field": "ids-field-v501",
  "ids-field-group": "ids-field-group-v501",
  logoImage: d,
  panel: r,
  logoSlot: v,
  "ids-menu--inline": "ids-menu--inline-v501",
  "ids-menuItem": "ids-menu-item-v501",
  "ids-badge--host": "ids-badge--host-v501",
  "ids-popover": "ids-popover-v501",
  "ids-combobox": "ids-combobox-v501",
  "ids-popover--activator": "ids-popover--activator-v501",
  "ids-popover--content": "ids-popover--content-v501",
  "ids-label": "ids-label-v501",
  "ids-select": "ids-select-v501",
  "ids-input": "ids-input-v501",
  "ids-tagListInput": "ids-tag-list-input-v501",
  "ids-input--wrapper": "ids-input--wrapper-v501",
  "ids-panel--background-transparent": "ids-panel--background-transparent-v501",
  "iress—background--transparent": "ids-navbar--iress—background--transparent-v501",
  content: l,
  contentBetween: p,
  contentEnd: b,
  toggleButton: c,
  logoIcon: g,
  slot: m,
  logoLink: u,
  fixed: k,
  "breakpoint--xs": "ids-navbar--breakpoint--xs-v501",
  navHide: x,
  "ids-menuItem--selected": "ids-menu-item--selected-v501",
  "breakpoint--sm": "ids-navbar--breakpoint--sm-v501",
  "breakpoint--md": "ids-navbar--breakpoint--md-v501",
  "breakpoint--lg": "ids-navbar--breakpoint--lg-v501",
  "breakpoint--xl": "ids-navbar--breakpoint--xl-v501",
  "breakpoint--xxl": "ids-navbar--breakpoint--xxl-v501"
}, L = ({
  logoSrc: n,
  logoAltText: o,
  onError: t,
  dataTestid: i
}) => /* @__PURE__ */ s(
  "img",
  {
    src: n,
    className: f.logoImage,
    "data-testid": a(i, "logo"),
    alt: o,
    onError: t
  }
);
export {
  L,
  f as s
};
